module.exports = __webpack_public_path__ + "static/media/Inter-ExtraBold-slnt=0.c88d8bbb.ttf";